import {
	SET_PERMISSIONS, 
} from './actionTypes';

const initState = {
    permissions: [],
}

const Permission = (state = initState, action) => {
	switch (action.type) {
		case SET_PERMISSIONS:
			return {
				...state,
				permissions: convertPermissionsToDict(action.payload)
			}

       
		default:
			return state;
	}
}

const convertPermissionsToDict = (permissions) => {
	let permissionsDict = {};
    if (permissions) {
        for (let item of permissions) {
            permissionsDict[item.permission.code] = item.permission.code;
        }
    }
	return permissionsDict;
}

export default Permission